export { default } from './InviteV2Customer';
